import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=46f18333&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=46f18333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f18333",
  null
  
)

export default component.exports